<script>
import TheFacultyStatisticsCard from "./TheFacultyStatisticsCard.vue";
import TabsStatisticAttestation from "./TabsStatisticAttestation.vue";
import CardStatisticAttestation from "./CardStatisticAttestation.vue";
import BarGraphStatisticAttestation from "./BarGraphStatisticAttestation.vue";
import axios from "axios";
import dataStatisticAttestationPartitionCoursesToDrawGraph
  from "./services/dataStatisticAttestationPartitionCoursesToDrawGraph";

export default {
  name: "CardGraphFacultyStatisticAttestation",
  components: {
    BarGraphStatisticAttestation,
    CardStatisticAttestation,
    TabsStatisticAttestation,
    TheFacultyStatisticsCard
  },

  props: {
    department: Number,
    required: true,
  },

  data() {
    return {
      loading: true,
      statistics: {},
      educationCodes: [],
      convertDataToDrawGraph: dataStatisticAttestationPartitionCoursesToDrawGraph,
    }
  },

  mounted() {
    this.getFacultyAttestationStatistics()
      .finally(() => this.loading = false);
  },

  computed: {

    xaxis() {
      return [..._.cloneDeep(this.educationCodes), "В среднем"];
    },
  },

  methods: {
    async getFacultyAttestationStatistics() {
      try {
        const response = await axios.get(`/report/faculty_statistic_by_graphs/${this.department}`);
        this.statistics = response.data.facultyStatistics;
        this.educationCodes = this.statistics?.meta?.educationProgramCodes;
      } catch (err) {
        console.log(err);
      }
    },

  },
}
</script>

<template>
  <card-statistic-attestation :loading="loading">
    <template #default>
      <v-card-title>{{statistics.meta.departmentName}}</v-card-title>
      <tabs-statistic-attestation
        :addition-name-key="statistics.meta.departmentName"
        :date-attestations="statistics.dateAttestations"
        v-slot="{dateAttestation}"
        sheet-class="d-flex justify-center"
      >
        <bar-graph-statistic-attestation
          :xaxis="xaxis"
          :series="convertDataToDrawGraph(dateAttestation.educationalAttestationStatistics, educationCodes)"
          :width="xaxis.length * 200"
        />
      </tabs-statistic-attestation>
    </template>
  </card-statistic-attestation>
</template>

<style scoped>

</style>